import { Typography } from '@components/Typography';
import clsx from 'clsx';

import {
  useInstantSearch,
  useNumericMenu,
  UseNumericMenuProps,
} from 'react-instantsearch';

export interface PriceRangeProps extends UseNumericMenuProps {
  enabled?: string;
}

export default function PriceRange<PriceRangeProps>(props) {
  const { items, refine } = useNumericMenu(props);

  const { enabled } = props;
  const { indexUiState, setIndexUiState } = useInstantSearch();

  if (
    enabled &&
    !indexUiState?.refinementList?.productCategoryId?.includes(
      enabled.toUpperCase()
    )
  ) {
    return null;
  }

  return (
    <div>
      <Typography tag="p" size="text-lg" weight="font-semibold">
        Price Range
      </Typography>
      <div className=" mt-2 flex w-full overflow-hidden rounded-lg border border-gray-400 bg-white">
        {items.map((item, index) => {
          return (
            <div
              key={index}
              onClick={(event) => {
                event.preventDefault();
                if (item.isRefined) {
                  refine(items[items.length - 1].value);
                } else {
                  refine(item.value);
                }
              }}
              className={clsx(
                'flex flex-1 cursor-pointer items-center justify-center py-3',
                item.isRefined ? 'bg-brand-mudjimba/30' : 'bg-white'
              )}>
              <div>
                <Typography tag="p" size="text-base">
                  {item.label}
                </Typography>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
